export default {
      id: "ic_date_picker-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_date_picker-usage",
      toString: function () {
        return this.url;
      }
    }